"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PickPathTransform = void 0;
const IProduceValueEvents_1 = require("./IProduceValueEvents");
const ListenerCollection_1 = require("./ListenerCollection");
class PickPathTransform {
    constructor(path, producer) {
        this.listenerCollection = new ListenerCollection_1.ListenerCollection();
        this.path = path;
        producer.registerValueEventListener((status, error, value) => {
            const transformed = this.transformValueEvent(status, error, value);
            this.invokeRegisteredListeners(...transformed);
        });
    }
    registerValueEventListener(listener) {
        return this.listenerCollection.add(listener);
    }
    transformValueEvent(status, error, value) {
        if (status !== IProduceValueEvents_1.ValueStatus.Ok) {
            return [status, error, null];
        }
        if (!this.hasValue(value)) {
            return [IProduceValueEvents_1.ValueStatus.Unavailable, null, null];
        }
        return [IProduceValueEvents_1.ValueStatus.Ok, null, this.pickValue(value)];
    }
    hasValue(value) {
        if (value === null || typeof value !== "object") {
            return false;
        }
        return this.path in value;
    }
    pickValue(value) {
        return value[this.path];
    }
    invokeRegisteredListeners(status, error, value) {
        console.log("invokeListeners value:", value);
        this.listenerCollection.invoke(status, error, value);
    }
}
exports.PickPathTransform = PickPathTransform;
//# sourceMappingURL=PickPathTransform.js.map